import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { Container, Box, Button } from 'theme-ui';
import { Banner, Tiles } from '..';
import Testimonials from './testimonials';
import Graph from '../components/graph';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Banner mdxType="Banner">
      <Graph mdxType="Graph" />
      <h1 {...{
        "id": "theme-ui-the-design-graph-framework"
      }}>{`Theme UI: The Design Graph Framework`}</h1>
      <p>{`Theme UI is a library for creating themeable user interfaces based on constraint-based design principles.
Build custom component libraries, design systems, web applications, Gatsby themes, and more
with a flexible API for best-in-class developer ergonomics.`}</p>
      <p><a parentName="p" {...{
          "href": "/getting-started"
        }}>{`Documentation`}</a>{`
`}<a parentName="p" {...{
          "href": "https://github.com/system-ui/theme-ui"
        }}>{`GitHub`}</a></p>
      <p><img parentName="p" {...{
          "src": "https://flat.badgen.net/github/stars/system-ui/theme-ui",
          "alt": "Stars"
        }}></img>{`
`}<img parentName="p" {...{
          "src": "https://flat.badgen.net/github/status/system-ui/theme-ui",
          "alt": "Build Status"
        }}></img>{`
`}<img parentName="p" {...{
          "src": "https://flat.badgen.net/npm/v/theme-ui",
          "alt": "Version"
        }}></img>{`
`}<img parentName="p" {...{
          "src": "https://flat.badgen.net/badge/license/MIT/blue",
          "alt": "MIT License"
        }}></img>{`
`}<img parentName="p" {...{
          "src": "https://flat.badgen.net/bundlephobia/minzip/theme-ui",
          "alt": "bundle size badge"
        }}></img></p>
    </Banner>
    <Container mdxType="Container">
      <Tiles columns={2} mdxType="Tiles">
        <ol>
          <li parentName="ol">
            <h2 parentName="li" {...{
              "id": "create-your-theme"
            }}>{`Create your theme`}</h2>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-javascript"
              }}>{`export default {
  colors: {
    text: '#000',
    background: '#fff',
    primary: 'tomato',
  },
  fonts: {
    body: 'system-ui, sans-serif',
    heading: '"Avenir Next", sans-serif',
  },
}
`}</code></pre>
          </li>
          <li parentName="ol">
            <h2 parentName="li" {...{
              "id": "style-your-ui"
            }}>{`Style your UI`}</h2>
            <pre parentName="li"><code parentName="pre" {...{
                "className": "language-jsx"
              }}>{`/** @jsx jsx */
import { jsx } from 'theme-ui'
export default props => (
  <h1
    sx={{
      color: 'primary',
      fontFamily: 'heading',
    }}>
    Hello
  </h1>
)
`}</code></pre>
          </li>
        </ol>
      </Tiles>
      <Tiles mdxType="Tiles">
        <ul>
          <li parentName="ul"><h2 parentName="li" {...{
              "id": "ergonomic"
            }}>{`Ergonomic`}</h2>{`Best-in-class developer ergonomics let you style
your application quickly and consistently
based on your theme`}</li>
          <li parentName="ul"><h2 parentName="li" {...{
              "id": "themeable"
            }}>{`Themeable`}</h2>{`Quickly and easily reference values from your theme
throughout your entire application, on any component`}</li>
          <li parentName="ul"><h2 parentName="li" {...{
              "id": "constraint-based"
            }}>{`Constraint-based`}</h2>{`Use color, typography, and layout scales
rooted in constraint-based design principles`}</li>
        </ul>
      </Tiles>
      <Testimonials mdxType="Testimonials" />
      <Tiles sx={{
        fontWeight: 'bold',
        a: {
          display: 'block',
          color: 'inherit',
          textDecoration: 'none',
          ':hover': {
            textDecoration: 'underline'
          }
        }
      }} mdxType="Tiles">
        <ul>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/getting-started/#sx-prop"
            }}>{`Theme-aware `}<inlineCode parentName="a">{`sx`}</inlineCode>{` prop for CSS`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components"
            }}>{`30+ Built-in primitive UI components`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/styling-mdx"
            }}>{`Simple, expressive MDX styling`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/getting-started/#sx-prop"
            }}>{`Style with or without creating components`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/styling-mdx/#typographyjs"
            }}>{`Use Typography.js themes`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/getting-started/#responsive-styles"
            }}>{`Easy, mobile-first responsive styles`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/color-modes"
            }}>{`Built-in dark mode`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/gatsby-plugin"
            }}>{`Plugin for Gatsby sites and themes`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/theming"
            }}>{`Robust theming API`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/theme-spec"
            }}>{`Backed with a Theme Specification`}</a></li>
        </ul>
      </Tiles>
      <Box py={6} mdxType="Box">
        <h2 {...{
          "id": "get-started"
        }}>{`Get Started`}</h2>
        <Button as='a' href='/getting-started' variant='black' mdxType="Button">
  Explore the Docs
        </Button>
      </Box>
    </Container>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      